import React from 'react';
import PropTypes from 'prop-types';

export default class VerifyForm extends React.Component {
    // TODO: Handle case where there is no suggestion
    render() {
        let suggestedAddress = null;
        if ( this.props.verifiedAddress.country === 'USA' ) {
            suggestedAddress = (
            <div className="rec-form-check-wrap">
                <label htmlFor="suggested" className="rec-label-radio">
                    <input className="rec-input-hide" id="suggested" type="radio" name="suggested" value="suggested" onChange={this.props.handleOptionChange} />
                    <span className="rec-input-radio" />
                    <strong>Use Suggested Address</strong>
                    <address>
                        <div>{this.props.verifiedAddress.address1}</div>
                        <div>{this.props.verifiedAddress.address2}</div>
                        <div>{this.props.verifiedAddress.city}, {this.props.verifiedAddress.state} {this.props.verifiedAddress.zip_code}</div>
                        <div>{this.props.verifiedAddress.country}</div>
                    </address>
                </label>
            </div>
        );
        }
        return (
            <div>
                <div className="rec-verify-contact-row">
                    {suggestedAddress}
                    <div className="rec-form-check-wrap">
                        <label htmlFor="original" className="rec-label-radio">
                            <input className="rec-input-hide" id="original" type="radio" name="suggested" value="original" onChange={this.props.handleOptionChange} />
                            <span className="rec-input-radio" />
                            <strong>Use Original Address</strong>
                            <address>
                                <div>{this.props.currentAddress.address1}</div>
                                <div>{this.props.currentAddress.address2}</div>
                                <div>{this.props.currentAddress.city}, {this.props.currentAddress.state} {this.props.currentAddress.zip_code}</div>
                                <div>{this.props.currentAddress.country}</div>
                            </address>
                        </label>
                    </div>
                </div>
                <div className="rec-verify-contact-footer">
                    <button
                        className="rec-button-primary"
                        onClick={this.props.saveProfile}>
                        Save
                    </button>
                    <button
                        className="rec-button-tertiary"
                        onClick={this.props.editProfile}>
                        Edit Address
                    </button>
                </div>
            </div>
        )
    }
}

VerifyForm.propTypes = {
    handleOptionChange: PropTypes.func.isRequired,
    saveProfile: PropTypes.func.isRequired,
    editProfile: PropTypes.func.isRequired,
    verifiedAddress: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip_code: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    currentAddress: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip_code: PropTypes.string,
        country: PropTypes.string
    }).isRequired
};
